// src/lib/useHeatmapInit.ts
import { useEffect, useRef } from "react";
import { useHeatmapStore } from "./heatmapStore";
import { syncLgsOnce } from "./lgsSync";

export function useHeatmapInitFull(enable: boolean = true) {
  const startedRef = useRef(false);
  const loadAllUserHeat = useHeatmapStore((s) => s.loadAllUserHeat);
  const fetchNearbyLgs = useHeatmapStore((s) => s.fetchNearbyLgs);
  useEffect(() => {
    if (!enable) return;
    if (startedRef.current) return;
    startedRef.current = true;

    loadAllUserHeat();
    let done = false;
    const fallback = () => {
      if (!done) fetchNearbyLgs({ lat: 39.5, lng: -98.35, force: true });
    };
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (p) => {
          if (done) return;
          fetchNearbyLgs({
            lat: p.coords.latitude,
            lng: p.coords.longitude,
            force: true,
          });
          done = true;
        },
        () => fallback(),
        { enableHighAccuracy: true, timeout: 7000 }
      );
    } else {
      fallback();
    }
  }, [enable, loadAllUserHeat, fetchNearbyLgs]);
}

// Full page hook (same for now)
export function useHeatmapInitWidget() {
  const loadHeat = useHeatmapStore((s) => s.loadAllUserHeat);
  const loadWidgetLgs = useHeatmapStore((s) => s.loadWidgetLgs);
  const fetchNearbyLgs = useHeatmapStore((s) => s.fetchNearbyLgs);

  useEffect(() => {
    loadHeat();
  }, [loadHeat]);

  // Load LGS near user if possible; fallback to neutral center after delay
  useEffect(() => {
    let got = false;
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          got = true;
          loadWidgetLgs([pos.coords.latitude, pos.coords.longitude]);
        },
        () => {},
        { enableHighAccuracy: true, maximumAge: 15000, timeout: 10000 }
      );
    }
    const t = setTimeout(() => {
      if (!got) loadWidgetLgs([20, 0]); // fallback global-ish
    }, 2000);
    return () => clearTimeout(t);
  }, [loadWidgetLgs]);

  useEffect(() => {
    syncLgsOnce();
  }, []);

  useEffect(() => {
    if (!("geolocation" in navigator)) return;
    navigator.geolocation.getCurrentPosition(
      (p) =>
        fetchNearbyLgs({
          lat: p.coords.latitude,
          lng: p.coords.longitude,
          force: true,
        }),
      () => {},
      { enableHighAccuracy: true, timeout: 5000 }
    );
  }, [fetchNearbyLgs]);
}

